<template>
  <div class="container-fluid">
    <!-- <h1>{{$t("message")}}</h1> -->
    <div class="row mt-5">
      <no-data-box v-if="isCustomerSettingEnabled(authUser, 'is_webshop_enabled') == '0' || authUser.customer_instance.stripe_connect_active_account == null">
        <h5 class="mb-0">
          {{ $t(LangConstants.feature_not_available_text) }}
        </h5>
      </no-data-box>
      <div class="col-md-12" v-if="isCustomerSettingEnabled(authUser, 'is_webshop_enabled') == '1'">
        <h3 v-if="authUser.customer_instance.stripe_connect_active_account != null">
          <b> {{ $t(LangConstants.webshop_header_text) }} </b>
        </h3>
        <no-data-box v-if="authUser.customer_instance.stripe_connect_active_account != null && authUser.customer_instance.stripe_connect_active_account.onboarded == false">
          <h5>
            {{ $t(LangConstants.enable_webshop_helper_text) }}
          </h5>
          <div class="row mt-4">
            <div class="col-md-6 mx-auto">
              <my-button :label="$t(LangConstants.onboard_your_account_button_label)" variant="solid-primary" classes="mr-1" height="56px" width="100%" type="button" @onClick="createStripeOnboardingLink()"></my-button>
            </div>
          </div>
        </no-data-box>
        <b-form class="" ref="" @submit.stop.prevent="proceedBtnHandler" v-if="authUser.customer_instance.stripe_connect_active_account != null && authUser.customer_instance.stripe_connect_active_account.onboarded == true">
          <div class="row d-flex justify-content-center">
            <div class="col-md-12">
              <div class="mb-4">
                <text-input-group id="my-name" name="my-name" mandatory="true" :label="$t(LangConstants.generated_webshop_code_text_group_text)" :placeholder="$t(LangConstants.generated_webshop_code_text_group_text)" inlinerows="false" classes="bg-gray" btn_fa="code" :btn_label="$t(LangConstants.generate_code_button_label)" btn_variant="solid-primary" btn_classes="" btn_width="100%" btn_readOnly="true" v-model="ifrfameLink" ref="formUrl" @onClick="saveAndCopyFormUrl()"></text-input-group>
              </div>
            </div>
          </div>
        </b-form>
      </div>
    </div>
    <div class="row mt-5" v-if="authUser.customer_instance.stripe_connect_active_account != null && authUser.customer_instance.stripe_connect_active_account.onboarded == true && isCustomerSettingEnabled(authUser, 'is_webshop_enabled') == '1'">
      <div class="col-12">
        <h3>
          <b> {{ $t(LangConstants.courses_header_text) }} </b>
        </h3>
        <b-tabs content-class="" class="custom-tab-control">
          <b-tab active title="first">
            <template #title>
              <i class="fa fa-cog" aria-hidden="true"></i>
              &nbsp; <span>{{ $t(LangConstants.settings_tab_title) }}</span>
            </template>
            <div class="container-fluid form-base pt-0 pb-0">
              <div class="row sort-menu">
                <div class="col-3 p-0 sort-menu-item">
                  <my-button fa="sort" fapos="right" :label="$t(LangConstants.in_webshop_column_title)" variant="sort" classes="mr-1" height="56px" width="100%" type="button" @onClick="sortCourseByInWebshop()"></my-button>
                </div>
                <div class="col-5 p-0 sort-menu-item">
                  <my-button fa="sort" fapos="right" :label="$t(LangConstants.course_title_column_title)" variant="sort" classes="mr-1" height="56px" width="100%" type="button" @onClick="sortCourseByTitle()"></my-button>
                </div>
                <div class="col-4 p-0 sort-menu-item">
                  <my-button fa="sort" fapos="right" :label="$t(LangConstants.price_column_title)" variant="sort" classes="mr-1" height="56px" width="100%" type="button" @onClick="sortCourseByPrice()"></my-button>
                </div>
              </div>
              <template v-for="course in courses">
                <webshop-setting-item v-bind:key="course.courseid" :id="course.courseid" v-if="splittedCourses.includes(course.courseid)" :title="course.name" :thumbnail="course.image" :languages="course.languages" :duration="course.duration" :summary="course.summary" :webshop="getCurrentWebShopInstance(course)" :webshopstatic="getCurrentWebShopStaticInstance(course)" :previewURL="getPreviewUrl(course.courseid)" @change="handleWebshopChange" />
              </template>
              <div class="row">
                <div class="mx-auto">
                  <pagination :rows="coursesCount" :perPage="itemsPerPage" class="" ariacontrols="courses-list" @change="handlePageChange" align="center" />
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab title="Second">
            <template #title>
              <i class="fa fa-shopping-cart" aria-hidden="true"></i>
              &nbsp; <span>{{ $t(LangConstants.shop_preview_tab_title) }}</span>
            </template>
            <div class="container-fluid">
              <shop-preview :webshop="shopPreviewWebShopItems" :enableSetDiscount="true" :isPreview="true" />
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * Webshop settings page
 */
import "../../assets/scss/webshop.scss";
import MyButton from "../../components/atoms/Button.vue";
import WebshopSettingItem from "../../components/organisms/WebshopSettingItem.vue";
import ShopPreview from "../../components/organisms/ShopPreview.vue";
import TextInputGroup from "../../components/organisms/TextInputGroup.vue";
import Pagination from "../../components/atoms/Pagination.vue";
import NoDataBox from "../../components/atoms/NoDataBox.vue";
import Common from "../../functions/index";
import Constants from "../../constants/index";
export default {
  name: "web-shop",
  async beforeCreate() {
    // await this.$store.dispatch("getCourses");
  },
  beforeMount() {},
  async created() {
    // alert('created');
    this.courses = await this.$store.dispatch("getCourses");
    this.coursesCount = this.courses.length;
    this.splitContent();
    this.initShopPreview();
    if (this.$route.query.force_refresh_user) {
      await this.$store.dispatch("retrieveUser").then(() => {
        const query = Object.assign({}, this.$route.query);
        delete query.force_refresh_user;
        this.$router.replace({ query });
        this.addEmbedUrl();
      });
    } else {
      this.addEmbedUrl();
    }

    this.setStaticCourses(this.courses); // await this.$store.dispatch("getCourses");
    // ___________________
    // this.ifrfameLink = content;
    // return content;
  },
  setup() {},
  data() {
    return {
      sortedbytitle: true,
      sortedbywebshop: true,
      sortedbyprice: true,
      currentPage: 1,
      itemsPerPage: 10,
      coursesCount: 0,
      courses: [],
      webshop: [],
      webshopStatic: [],
      splittedCourses: [],
      embedLink: "",
    };
  },
  methods: {
    setStaticCourses(courses) {
      for (const course of courses) {
        // console.log(course);

        if (course.web_shop_instance_active != null) {
          let item = {
            instance_id: course.instance_id,
            course_id: course.id,
            courseid: course.courseid,
            courseInstance: course,
            price: course.web_shop_instance_active.price,
            currency: course.web_shop_instance_active.currency,
            languages: course.web_shop_instance_active.languages,
            active: course.web_shop_instance_active.active,
            customer: course.web_shop_instance_active.customer,
            webshop: true,
            external_id: course.web_shop_instance_active.external_id,
          };

          this.webshopStatic.push(item);
        } else {
          for (let i = 0; i < this.webshopStatic.length; i++) {
            if (this.webshopStatic[i].courseid == course.courseid) {
              this.webshopStatic[i].active = false;
              this.webshopStatic[i].webshop = false;
            }
          }
        }
      }
    },

    getPreviewUrl(courseid) {
      const authUser = this.$store.getters.getAuthUser;
      const instnace_id = authUser.instance_id;
      return this.$store.getters.spInstanceVueURL + "company-account/web-shop/public/" + instnace_id + "/" + courseid;
    },

    addEmbedUrl() {
      let content;
      const authUser = this.$store.getters.getAuthUser;
      const instnace_id = authUser.instance_id;
      const url = this.$store.getters.spInstanceVueURL + "company-account/web-shop/public/" + instnace_id + "/0";
      content = `<iframe frameborder="0" scrolling="yes" seamless="seamless" style="display:block; width:100%;" id="pJCFusFJJ02cp7v4uwtfA" src="` + url + `" title="Webshop"></iframe>`;
      content += `<script> const X65fxOVTkeBQYiemvZZxA=window.addEventListener?"addEventListener":"attachEvent",ZFlYUbR37kqkxO5T0MmuIw=window[X65fxOVTkeBQYiemvZZxA],a0BiRNbzwUOfmpTiWIMRQ="attachEvent"==X65fxOVTkeBQYiemvZZxA?"onmessage":"message";ZFlYUbR37kqkxO5T0MmuIw(a0BiRNbzwUOfmpTiWIMRQ,e=>{isNaN(e.data)||(document.getElementById("pJCFusFJJ02cp7v4uwtfA").style.height=e.data+"px")},!1);</scr` + `ipt>`;

      this.$refs.formUrl.selectedValue = content;
      this.embedLink = content;
    },

    async saveAndCopyFormUrl() {
      const webshop = {
        webshop: this.webshop,
      };

      if (!this.validateWebshopPayload()) {
        this.$fire({
          title: this.$t(this.LangConstants.operation_could_not_completed_text),
          text: this.$t(this.LangConstants.webshop_save_error_message),
          type: "error",
          html: "",
        });
      } else {
        await this.$store.dispatch("updateWebShop", JSON.stringify(webshop)); //.then((result) => {
        const c = await this.$store.dispatch("getCourses", { force: true }); //.then((courses) => {

        //   });
        this.setStaticCourses(c);
        // console.log(result);

        this.webshopStatic = this.webshop;
        navigator.clipboard.writeText(this.embedLink);
        this.$bvToast.toast(this.$t(this.LangConstants.iframe_copied_success_text), {
          title: this.$t(this.LangConstants.information_heading),
          autoHideDelay: 2000,
          appendToast: false,
        });
        // });
      }
    },

    validateWebshopPayload() {
      return this.webshop.filter((item) => {
        return item.webshop == true && (item.price == null || item.languages == null);
      }).length > 0
        ? false
        : true;
    },

    sortCourseByPrice() {
      if (this.sortedbyprice == true) {
        this.courses.sort((c, d) => {
          return (c.web_shop_instance_active != null ? (c.web_shop_instance_active.price != undefined ? c.web_shop_instance_active.price : 0) : 0) - (d.web_shop_instance_active != null ? (d.web_shop_instance_active.price != undefined ? d.web_shop_instance_active.price : 0) : 0);
        });
      } else {
        this.courses.sort((c, d) => {
          return (d.web_shop_instance_active != null ? (d.web_shop_instance_active.price != undefined ? d.web_shop_instance_active.price : 0) : 0) - (c.web_shop_instance_active != null ? (c.web_shop_instance_active.price != undefined ? c.web_shop_instance_active.price : 0) : 0);
        });
      }

      this.splitContent();
      this.sortedbyprice = this.sortedbyprice == true ? false : true;
    },

    sortCourseByTitle() {
      if (this.sortedbytitle == true) {
        this.courses.sort((a, b) => (a.name > b.name ? -1 : 1));
      } else {
        this.courses.sort((a, b) => (a.name > b.name ? 1 : -1));
      }

      this.splitContent();
      this.sortedbytitle = this.sortedbytitle == true ? false : true;
    },

    sortCourseByInWebshop() {
      if (this.sortedbywebshop == true) {
        this.courses.sort((a) => (a.web_shop_instance_active ? -1 : 1));
      } else {
        this.courses.sort((a) => (!a.web_shop_instance_active ? -1 : 1));
      }

      this.splitContent();
      this.sortedbywebshop = this.sortedbywebshop == true ? false : true;
    },

    handlePageChange(page) {
      this.currentPage = page;
      this.splitContent();
    },

    splitContent() {
      this.splittedCourses = this.courses.slice((this.currentPage - 1) * this.itemsPerPage, this.currentPage * this.itemsPerPage).map((course) => course.courseid);
    },

    handleWebshopChange(payload) {
      const courseIndex = this.webshop.findIndex((course) => course.courseid == payload.id);

      if (courseIndex != -1) {
        this.webshop[courseIndex][payload.column] = payload.value;
      } else {
        const course = this.courses.find((course) => course.courseid == payload.id);
        // course[payload.column] = payload.value;
        // console.log(course);
        let item = {
          instance_id: course.instance_id,
          course_id: course.courseid,
          courseid: course.courseid,
          courseInstance: course,
          price: null,
          customer: course.customer,
          currency: "SEK",
          languages: null,
          active: true,
          webshop: false,
        };

        item[payload.column] = payload.value;

        this.webshop.push(item);
      }

      // Make shop instance nullable
      const courseIndexWebShop = this.courses.findIndex((course) => course.courseid == payload.id);

      if (this.courses[courseIndexWebShop]["web_shop_instance_active"] == null) {
        this.courses[courseIndexWebShop]["web_shop_instance_active"] = [];
      }

      this.courses[courseIndexWebShop]["web_shop_instance_active"][payload.column] = payload.value;
    },

    initShopPreview() {
      for (const course of this.courses) {
        if (course.web_shop_instance_active != null) {
          let item = {
            instance_id: course.instance_id,
            course_id: course.id,
            courseid: course.courseid,
            courseInstance: course,
            price: course.web_shop_instance_active.price,
            currency: course.web_shop_instance_active.currency,
            languages: course.web_shop_instance_active.languages,
            active: course.web_shop_instance_active.active,
            customer: course.web_shop_instance_active.customer,
            webshop: true,
            external_id: course.web_shop_instance_active.external_id,
          };

          this.webshop.push(item);
        }
      }
    },

    createStripeOnboardingLink() {
      const accountId = this.authUser.customer_instance.stripe_connect_active_account != null ? this.authUser.customer_instance.stripe_connect_active_account.account_id : null;

      let apiBaseURL = "";

      if (Common.isValidHttpUrl(process.env.VUE_APP_API_BASE_URL) == true) {
        apiBaseURL = process.env.VUE_APP_API_BASE_URL;
      } else {
        apiBaseURL = this.$store.getters.instanceUrl + process.env.VUE_APP_API_BASE_URL;
      }

      const payload = {
        params: {
          account: accountId,
          refresh_url: apiBaseURL + "/stripe/accountlink/refresh/" + accountId,
          return_url: apiBaseURL + "/stripeconnectaccount/onboarding/return/" + accountId,
          type: "account_onboarding",
        },
        options: null,
      };

      this.$store.dispatch("createAccountLink", JSON.stringify(payload)).then((result) => {
        // console.log(result);
        if (result.success == true) {
          // Redirect result.data.url
          window.location.href = result.data.url;
        }
      });
    },

    getCurrentWebShopInstance(course) {
      for (const item of this.webshop) {
        if (item.courseid == course.courseid) {
          return item;
        }
      }
      return null;
    },

    getCurrentWebShopStaticInstance(course) {
      for (const item of this.webshopStatic) {
        if (item.courseid == course.courseid) {
          return item;
        }
      }
      return null;
    },

    isCustomerSettingEnabled(user, settingName) {
      return Common.isCustomerSettingEnabled(user, settingName);
    },
  },

  computed: {
    // itemsPerPage(){
    //   const authUser = this.$store.getters.getAuthUser;
    //   return Common.isCustomerSettingEnabled(authUser, 'items_per_page');
    // },
    authUser() {
      return this.$store.getters.getAuthUser;
    },

    shopPreviewWebShopItems() {
      return this.webshop.filter((item) => item.webshop == true);
    },
    LangConstants() {
      return Constants;
    },

    //   // courses() {
    //   //   return this.$store.getters.courses;
    //   // },
    //   coursesCount(){
    //     if(this.$store.getters.courses != null){
    //       return this.$store.getters.courses.length
    //     }
    //     return 0
    //   },
    // ifrfameLink(){
    // },
  
  },
  components: {
    MyButton,
    WebshopSettingItem,
    ShopPreview,
    TextInputGroup,
    Pagination,
    NoDataBox,
  },
};
</script>
